import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { axiosInstance } from "@/pages/auth/auth.context";
import { BonusForm, BonusFormValues } from "./BonusForm";
import { useState } from "react";
import { BonusType } from "@/types/bonus";
import { format } from "date-fns";

export default function CreateBonus() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const initialValues: BonusFormValues = {
    title: "",
    bonusType: BonusType.SEASONAL,
    startDate: new Date(),
    endDate: new Date(),
    requiredParties: null,
    dollarAmount: null,
    topN: null,
    notes: null,
  };

  const handleSubmit = async (values: BonusFormValues) => {
    setIsLoading(true);
    try {
      const data = {
        ...values,
        startDate: format(values.startDate, "yyyy-MM-dd"),
        endDate: format(values.endDate, "yyyy-MM-dd"),
      };
      const response = await axiosInstance.post("bonus", data);
      if (response.status === 201) {
        toast({
          title: "Success",
          description: "Bonus program created successfully",
          variant: "success",
        });
        navigate("/admin/bonuses");
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Unknown error occurred";
      toast({
        title: "Error",
        description: errorMessage + " Data not submitted.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-6 max-w-xl">
      <h1 className="text-3xl font-bold mb-6">Create New Bonus Program</h1>
      <BonusForm
        initialValues={initialValues}
        onSubmit={handleSubmit}
        loading={isLoading}
        submitLabel="Create Bonus Program"
        cancelLabel="Cancel"
        onCancel={() => navigate("/admin/bonuses")}
      />
    </div>
  );
}
